export const GET_MATERIALS = 'materials/GET_MATERIALS';
export const GET_MATERIALS_SUCCESS = 'materials/GET_MATERIALS_SUCCESS';
export const GET_MATERIALS_ERROR = 'materials/GET_MATERIALS_ERROR';
